// アポロ管財情報
export const APOLLO_INFO = {
  name: 'アポロ管財株式会社',
  zip: '〒201-0015',
  address: '東京都狛江市猪方3-36-3',
  tel: '03-5438-8804',
  fax: '03-5438-8809'
}

// メインタスクお問い合わせカテゴリ
export const categorySelections = [
  {
    value: '業務依頼',
    text: '業務依頼'
  },
  {
    value: '確認・質問',
    text: '確認・質問'
  },
  {
    value: '見積依頼',
    text: '見積依頼',
  },
  {
    value: '変更処理（解約・変更）',
    text: '変更処理（解約・変更）'
  },
  {
    value: '受注処理（新規・金額変更）',
    text: '受注処理（新規・金額変更）'
  },
  {
    value: 'クレーム',
    text: 'クレーム'
  },
  {
    value: 'その他',
    text: 'その他'
  },
  {
    value: '追加依頼',
    text: '追加依頼'
  },
  {
    value: 'デンタツ',
    text: 'デンタツ'
  },
  {
    value: '非公開依頼',
    text: '非公開依頼'
  },
  {
    value: '張り紙',
    text: '張り紙'
  },
  {
    value: 'システム予定変更',
    text: 'システム予定変更'
  },
  {
    value: '面接関連',
    text: '面接関連'
  },
  {
    value: '雇い入れ（清掃員）',
    text: '雇い入れ（清掃員）'
  },
  {
    value: '雇い入れ（社員）',
    text: '雇い入れ（社員）'
  },
  {
    value: '同行',
    text: '同行'
  },
  {
    value: '期限切れ募集',
    text: '期限切れ募集'
  },
  {
    value: 'AKBS休み登録',
    text: 'AKBS休み登録'
  },
  {
    value: 'AKBS録音確認',
    text: 'AKBS録音確認'
  },
  {
    value: 'AKBS復帰確認',
    text: 'AKBS復帰確認'
  },
]

// メインタスク 複数人同時登録が可能なお問い合わせカテゴリ
// ＊この5つ以外のカテゴリが1つでも選択されている場合は複数登録不可（混在不可）
export const MULTI_REGIST_CATEGORIES = [
  '業務依頼',
  '確認・質問',
  'その他',
  '追加依頼',
  'デンタツ',
  '見積り'
]

// 改行コード（見積_カテゴリ名）ここを変更した場合は、帳票や契約書の変更も必須
export const newLineCode = /@@/g

export const ESTIMATE_TYPES = [
  {
    typeId: 'normal',
    name: '通常見積り'
  },
]

// 見積ステータス
export const ESTIMATE_STATUS = [
  { 
    id: 'all',
    name: '全て',
    color: 'gray',
    close: false
  },
  { 
    id: 'inprogress', 
    name: '作成中',
    color: 'orange',
    close: false
  },
  { 
    id: 'awaitingApproval', 
    name: '承認申請中',
    color: 'green',
    close: false
  },
  { 
    id: 'rejectionApproval', 
    name: '差戻',
    color: 'red',
    close: false
  },
  { 
    id: 'incomplete',
    name: 'メインタスク未完了',
    color: 'gray',
    close: false
  },
  {
    id: 'myApproval',
    name: '担当の承認待ち',
    color: 'gray',
    close: false
  },
  {
    id: 'ordered',
    name: '受注',
    color: 'purple2',
    close: true
  },
]

// 見積ステータスカラー
const addStatus = [
  { 
    id: 'approved', 
    name: '承認済み',
    color: 'lightGreen',
    close: false
  },
  { 
    id: 'awaitingApproval', 
    name: '承認待ち',
    color: 'pink',
    close: false
  },
  { 
    id: 'completed', 
    name: '作成完了',
    color: 'blueGray',
    close: false
  },
  {
    id: 'ordered',
    name: '受注登録中',
    color: 'purple2',
    close: true
  },
  {
    id: 'ordered',
    name: '受注完了',
    color: 'lightGreen',
    close: true
  },
  {
    id: 'reject',
    name: '却下',
    color: 'black',
    close: true
  },
]
export const ESTIMATE_STATUS_COLOR
  = ESTIMATE_STATUS.concat(addStatus)

// 消費税率
export const TAX_RATE = 10

// 見積書PDFファイル名
export const ESTIMATE_PDF_FILE_NAME = '【御見積書】{{estimateNo}}_{{buildingName}}.pdf'
export const ESTIMATE_PDF_FILE_NAME_ORDER = '【御注文書】{{estimateNo}}_{{buildingName}}.pdf'
export const ESTIMATE_COVER_PAGE_PDF_FILE_NAME = `【送付状】${ESTIMATE_PDF_FILE_NAME}`

export * as SOLID_ICONS from '@vue-hero-icons/solid'
export * as OUTLINE_ICONS from '@vue-hero-icons/outline'

// 巡回
export const WEIGHT = 15

// 特別清掃 作業項目
export const SPECIALCLEAN_WORK_ITEMS = [
  { value: '腰壁清掃', id: 'wall' },
  { value: '照明器具清掃', id: 'lighting' },
  { value: 'エントランス等石材酸洗浄', id: 'acid' },
  { value: 'エントランスコーティング（皮膜タイプ）', id: 'filmCoating' },
  { value: 'エントランスコーティング（浸透性タイプ）', id: 'penetrationCoating' },
  { value: 'ガラリ清掃', id: 'garari' },
  { value: '側溝', id: 'gutter' },
  { value: '枡清掃', id: 'masu' },
  { value: '駐車場ピット内清掃', id: 'parking' },
  { value: '安全対策要員', id: 'safety' },
  { value: '釜場清掃（スコップ）', id: 'shovel' },
  { value: '汚泥処理', id: 'sludge' },
  { value: 'インターロッキング洗浄', id: 'inter' },
  { value: '屋上ドレン清掃', id: 'drain' },
  { value: '駐輪場清掃', id: 'bicycle' },
  { value: '駐輪場屋根', id: 'roof' },
  { value: '壁面拭き上げ', id: 'wipe' },
  { value: 'エアコンフィルター清掃', id: 'filter' },
  { value: 'ルーバー', id: 'louver' },
  { value: '機械式駐車場パレット清掃（掃き）20/日', id: 'twentyPallet' },
  { value: '機械式駐車場パレット清掃（掃き）50/日', id: 'fiftyPallet' },
  { value: 'クーラーフェンス', id: 'fence' },
  { value: '天井清掃(ステンレス）', id: 'ceiling' },
  { value: '水景(池)清掃', id: 'pond' },
  { value: '外廊下面格子・網戸清掃', id: 'lattice' },
  { value: '該当無', id: 'none' },
]

/**
 * 特別清掃 作業項目名 取得
 * @param {*} id ID
 * @returns 作業項目名
 */
export function getSpecialCleanWorkItemName(id) {
  const targets = SPECIALCLEAN_WORK_ITEMS.filter( i => { return i.id == id })
  if ( targets.length > 0 ) return targets[0].value
  else return ''
}


const APOLLO_CLIENT = {
  clientCode: '9999999999',
  clientName1: 'アポロ管財テスト用',
  clientName2: 'テスト',
}

export const APOLLO = [
  {
    clientCode: APOLLO_CLIENT.clientCode,
    clientName1: APOLLO_CLIENT.clientName1,
    clientName2: APOLLO_CLIENT.clientName2,
    siteCode: '999999999',
    siteName: 'アポロ管財物件テスト',
    zip: '',
    siteAddress: '',
    latitude: '',
    longitude: ''
  },
  {
    clientCode: APOLLO_CLIENT.clientCode,
    clientName1: APOLLO_CLIENT.clientName1,
    clientName2: APOLLO_CLIENT.clientName2,
    siteCode: '999999999_2',
    siteName: 'アポロ管財物件テスト_2',
    zip: '',
    siteAddress: '',
    latitude: '',
    longitude: ''
  },
  {
    clientCode: APOLLO_CLIENT.clientCode,
    clientName1: APOLLO_CLIENT.clientName1,
    clientName2: APOLLO_CLIENT.clientName2,
    siteCode: '999999999_3',
    siteName: 'アポロ管財物件テスト_3',
    zip: '',
    siteAddress: '',
    latitude: '',
    longitude: ''
  },
]


/**
 * 受注で使用する見積カテゴリのプロパティとコード、添付のプロパティー名
 */
export const PROPSET = [
  // ラウンドサービス
  {code: '1', val: 'orderRls', file: 'estimationRoundCommonFile', name: 'ラウンドサービス'},
  // ラウンドプラス
  {code: '2', val: 'orderRlsPlus', file: 'estimationRoundPlusCommonFile', name: 'ラウンドプラス'},
  // 日常清掃
  {code: '3', val: 'orderEverydays', file: 'estimationEverydayCommonFile', name: '日常清掃'},
  // 管理
  {code: '4', val: 'orderManagerWorks', file: 'managerWorkCommonFile', name: '管理員業務'},
  // 定期
  {code: '5', val: 'orderRegular', file: 'regularCleanCommonFile', name: '定期清掃'},
  // フロントサポート
  {code: '6', val: 'orderFront', file: 'frontSupportCommonFile', name: 'フロントサポート'},
  // フロントサポートプラス
  {code: '7', val: 'orderFrontPlus', file: 'frontSupportPlusCommonFile', name: 'フロントサポートプラス'},
  // ランドトラッシュ
  {code: '8', val: 'orderRlsTrash', file:'roundTrashCommonFile', name: 'ラウンドトラッシュ'},
  // クオリティーレポート
  {code: '9', val: 'orderQuality', file:'qualityReportCommonFile', name: 'クオリティレポート'},
  // ガラス清掃
  {code: '10', val: 'orderGlass', file:'glassCleanCommonFile', name: 'ガラス清掃'},
  // 排水管清掃
  {code: '11', val: 'orderDrain', file:'estimationDorainPipeCommonFile', name: '排水管清掃'},
  // 貯水槽清掃
  {code: '12', val: 'orderWaterTank', file:'estimationWaterTankCommonFile', name: '貯水槽清掃'},
  // 植栽剪定
  {code: '13', val: 'orderPlanting', file:'plantingCommonFile', name: '植栽剪定'},
  // 特別清掃
  {code: '14', val: 'orderSpecialCleans', file:'specialCleanCommonFile', name: '特別清掃'},
  // 消防設備点検
  {code: '15', val: 'orderFire', file:'fireInspectCommonFile', name: '消防設備点検'},
  // 建築設備定期検査
  {code: '16', val: 'orderConstruction', file:'constructionEquipmentInspectCommonFile', name: '建築設備定期検査'},
  // 特定建築物定期調査
  {code: '17', val: 'orderSpConstruction', file:'specificInspectCommonFile', name: '特定建築物定期調査'},
  // 共用部設備点検
  {code: '18', val: 'orderCommon', file:'commonAreaFacilityInspectionCommonFile', name: '共用部設備点検'},
  // エレベータ保守点検
  {code: '19', val: 'orderEv', file:'evInspectCommonFile', name: 'エレベーター保守点検'},
  // 増圧ポンプ点検
  {code: '20', val: 'orderPress', file:'pressPumpInspectCommonFile', name: '増圧ポンプ点検'},
  // 給排水ポンプ点検
  {code: '21', val: 'orderWaterSupply', file:'waterSupplyDrainagePumpInspectionCommonFile', name: '給排水ポンプ点検'},
  // 簡易専用水道
  {code: '22', val: 'orderSimpleWater', file:'simpleWaterSupplyCommonFile', name: '簡易専用水道'},
  // 管球対応
  {code: '23', val: 'orderTube', file:'tubeBulbSupportCommonFile', name: '管球対応'},
  // 粗大ごみ
  {code: '24', val: 'orderBulkyTrash', file:'bulkyWasteSupportCommonFile', name: '粗大ごみ対応'},
  // 物品販売
  {code: '25', val: 'orderSale', file:'merchandiseSalesCommonFile', name: '物品販売'},
  // 緊急対応
  {code: '26', val: 'orderEmergency', file:'emergencyResponseCommonFile', name: '緊急対応'},
  // 防火対象物点検
  {code: '27', val: 'orderFireObj', file:'firePreventionObjectInspectionCommonFile', name: '防火対象物点検'},
  // 汚水槽清掃
  {code: '101', val: 'orderSewage', file:'sewageTankCleaningCommonFile', name: '汚水槽清掃'},
  // 防火設備定期検査
  {code: '102', val: 'orderFireFixed', file:'fireProtectionInspectionCommonFile', name: '防火設備定期検査'},
  // 連結送水管耐圧性能点検
  {code: '103', val: 'orderConnented', file:'connectingWaterPipePressureInspectionCommonFile', name: '連結送水管耐圧性能点検'},
  // スポット清掃
  {code: '28', val: 'orderSpot', file:'', name: 'スポット清掃'},
  // MRS
  {code: '29', val: 'orderMRS', file:'mrsCommonFile', name: 'マンションローテーションサービス（MRS）'},
  // カテゴリーなし
  {code: 'none', val: 'orderOthers', file:'', name: ''},
]

/**
 * 面接・雇入れ（必要書類）
 */
export const MATERIAL_SELECTIONS = [
  {
    value: '業務報告書',
    text: '業務報告書'
  },
  // {
  //   value: '指定報告書',
  //   text: '指定報告書'
  // },
  {
    value: '返信用封筒',
    text: '返信用封筒'
  },
  {
    value: '代勤用賃金簿',
    text: '代勤用賃金簿'
  }
]

/**
 * 面接・雇入れ共通（東京23区+α）
 */
export const AREA_SELECTIONS = [
  '',
  '神奈川',
  '千葉',
  '埼玉',
  '千代田区',
  '中央区',
  '港区',
  '新宿区',
  '文京区',
  '台東区',
  '墨田区',
  '江東区',
  '品川区',
  '目黒区',
  '大田区',
  '世田谷区',
  '渋谷区',
  '中野区',
  '杉並区',
  '豊島区',
  '北区',
  '荒川区',
  '板橋区',
  '練馬区',
  '足立区',
  '葛飾区',
  '江戸川区',
  '多摩'
]

export const TOKYO_23 = [
  "千代田区",
  "中央区",
  "港区",
  "新宿区",
  "文京区",
  "台東区",
  "墨田区",
  "江東区",
  "品川区",
  "目黒区",
  "大田区",
  "世田谷区",
  "渋谷区",
  "中野区",
  "杉並区",
  "豊島区",
  "北区",
  "荒川区",
  "板橋区",
  "練馬区",
  "足立区",
  "葛飾区",
  "江戸川区"
];

/**
 * エリアとコード（変更したらバックエンドも要変更）
 * 過去に作られたエリアもあるため、現在新規登録で選択できるエリアよりも多い
 */
export const AREA_LIST = [
  { name: '多摩エリア', code: '001' },
  { name: '多摩北エリア', code: '002' },
  { name: '多摩南エリア', code: '003' },
  { name: '神奈川エリア', code: '004' },
  { name: '埼玉エリア', code: '005' },
  { name: '千葉エリア', code: '006' },
  { name: '東京西エリア', code: '007' },
  { name: '東京中央エリア', code: '010' },
  { name: '東京東エリア', code: '013' },
  { name: '東京北エリア', code: '014' },
  { name: '千代田区エリア', code: '101' },
  { name: '中央区エリア', code: '102' },
  { name: '港区エリア', code: '103' },
  { name: '新宿区エリア', code: '104' },
  { name: '文京区エリア', code: '105' },
  { name: '台東区エリア', code: '106' },
  { name: '墨田区エリア', code: '107' },
  { name: '江東区エリア', code: '108' },
  { name: '品川区エリア', code: '109' },
  { name: '目黒区エリア', code: '110' },
  { name: '大田区エリア', code: '111' },
  { name: '世田谷区エリア', code: '112' },
  { name: '渋谷区エリア', code: '113' },
  { name: '中野区エリア', code: '114' },
  { name: '杉並区エリア', code: '115' },
  { name: '豊島区エリア', code: '116' },
  { name: '北区エリア', code: '117' },
  { name: '荒川区エリア', code: '118' },
  { name: '板橋区エリア', code: '119' },
  { name: '練馬区エリア', code: '120' },
  { name: '足立区エリア', code: '121' },
  { name: '葛飾区エリア', code: '122' },
  { name: '江戸川区エリア', code: '123' }
]

/**
 * 東京23区+α
 */
export const AREA_SELECTIONS2 = [
  { check: false, area: '神奈川' },
  { check: false, area: '千葉' },
  { check: false, area: '埼玉' },
  { check: false, area: '東京都下' },
  { check: false, area: '東京23区' },
]

/**
 * 面接・雇入れ共通（作業内容）
 */
export const WORK_SELECTIONS = [
  {
    value: '日常清掃',
    text: '日常清掃',
    code: '10'
  },
  {
    value: '管理員',
    text: '管理員',
    code: '20'
  },
  {
    value: '管理員(日常清掃含)',
    text: '管理員(日常清掃含)',
    code: '30'
  },
  {
    value: '巡回員',
    text: '巡回員',
    code: '15'
  },
  {
    value: '代勤専門',
    text: '代勤専門',
    code: '50'
  }
] 

/**
 * 祝日区分
 */
export const HOLIDAYTYPE_SELECTIONS = [
  {
    value: 'FULL',
    text: 'FULL'
  },
  {
    value: '1時間',
    text: '1時間'
  },
  {
    value: '2時間',
    text: '2時間'
  },
  {
    value: '3時間',
    text: '3時間'
  },
  {
    value: '無',
    text: '無'
  }
] 

/**
 * 祝日区分（コードあり）
 */
export const HOLIDAY_LIST = [
  { value: '無', name: 'なし', code: 0 },
  { value: '1時間', name: '１時間出勤', code: 1 },
  { value: 'FULL', name: 'Full出勤', code: 2 },
  { value: '2時間', name: '２時間', code: 3 },
  { value: '3時間', name: '３時間', code: 4 }
]

/**
 * 有り無し
 */
export const YES_NO_SELECTIONS = [
  {
    value: '有',
    text: '有'
  },
  {
    value: '無',
    text: '無'
  }
]

/**
 * 有り無しCODE
 */
export const YES_NO_CODE = [
  {
    value: '1',
    text: '有'
  },
  {
    value: '0',
    text: '無'
  }
]

/**
 * 時間
 */
export const HOURS =  [
  { text: '7' },
  { text: '8' },
  { text: '9' },
  { text: '10' },
  { text: '11' },
  { text: '12' },
  { text: '13' },
  { text: '14' },
  { text: '15' },
  { text: '16' },
  { text: '17' },
  { text: '18' },
  { text: '19' },
  { text: '20' },
  { text: '21' },
  { text: '22' },
  { text: '23' }
]

/**
 * 分
 */
export const MINUTES = [
  { text: '00' },
  { text: '15' },
  { text: '30' },
  { text: '45' }
]

export const HOURS2 =  [
  { text: '6' },
  { text: '7' },
  { text: '8' },
  { text: '9' },
  { text: '10' },
  { text: '11' },
  { text: '12' },
  { text: '13' },
  { text: '14' },
  { text: '15' },
  { text: '16' },
  { text: '17' },
  { text: '18' },
  { text: '19' },
  { text: '20' },
  { text: '21' }
]

export const MINUTES2 = [
  { text: '00' },
  { text: '10' },
  { text: '15' },
  { text: '20' },
  { text: '25' },
  { text: '30' },
  { text: '35' },
  { text: '40' },
  { text: '45' },
  { text: '50' },
  { text: '55' }
]

/**
 * 曜日
 */
export const DAYS_SELECTIONS = [
  {
    value: '月',
    text: '月'
  },
  {
    value: '火',
    text: '火'
  },
  {
    value: '水',
    text: '水'
  },
  {
    value: '木',
    text: '木'
  },
  {
    value: '金',
    text: '金'
  },
  {
    value: '土',
    text: '土'
  },
  {
    value: '日',
    text: '日'
  }
]

/**
 * 曜日
 */
export const WEEKS = [
  '月',
  '火',
  '水',
  '木',
  '金',
  '土',
  '日'
]

/**
 * 曜日と曜日番号
 */
export const WEEK_NUM = [
  {
    value: 1,
    text: '月'
  },
  {
    value: 2,
    text: '火'
  },
  {
    value: 3,
    text: '水'
  },
  {
    value: 4,
    text: '木'
  },
  {
    value: 5,
    text: '金'
  },
  {
    value: 6,
    text: '土'
  },
  {
    value: 0,
    text: '日'
  }
]

export const WEEK_NUM_TO_NAME = [
  '日',
  '月',
  '火',
  '水',
  '木',
  '金',
  '土'
]

/**
 * 交通費区分
 */
export const PROVISION_SELECTIONS = [
  {
    value: '１日',
    text: '１日'
  },
  {
    value: '１ヵ月',
    text: '１ヵ月'
  },
  {
    value: '無',
    text: '無'
  }
]

/**
 * 交通費区分 2
 */
export const PROVISION_SELECTIONS2 = [
  {
    value: '0',
    text:  ''
  },
  {
    value: '1',
    text: '１日'
  },
  {
    value: '2',
    text: '１ヵ月'
  }
]

/**
 * サブタスクマスタで設定する期限のもととなる日
 */
export const SUB_TASK_LIMIT = [
  {
    name: '登録日',
    value: null
  },
  {
    name: '入社日',
    value: 'employmentHireDate'
  },
  {
    name: '退職日',
    value: 'employmentRetirementDate'
  }
]

/**
 * 週休〇日制
 */
export const WEEKLY_HOLIDAYS = [
  {
    value: '週休2日制',
    text: '週休2日制'
  },
  {
    value: '週休3日制',
    text: '週休3日制'
  }
]

/**
 * 出勤形態（変更したら、受注のsetRemarksValも変更！！）
 */
export const ATTENDANCE_TYPES = [
  {
    value: '',
    text:  ''
  },
  {
    value: '00',
    text:  ''
  },
  {
    value: '01',
    text:  '第 1,3,5 週'
  },
  {
    value: '02',
    text:  '第 1,3 週'
  },
  {
    value: '03',
    text:  '第 2,4 週'
  },
  {
    value: '04',
    text:  '第 1 週'
  },
  {
    value: '05',
    text:  '第 2 週'
  },
  {
    value: '06',
    text:  '第 3 週'
  },
  {
    value: '07',
    text:  '第 4 週'
  },
  {
    value: '08',
    text:  '第 5 週'
  },
  {
    value: '09',
    text:  '隔週'
  },
  {
    value: '10',
    text:  '第 2,4,5 週'
  },
  {
    value: '11',
    text:  '第 1,3,4 週'
  },
  {
    value: '12',
    text:  '第 1,2,5 週'
  },
  {
    value: '13',
    text:  '第 2,3 週'
  }
]

export const WEEK_DETAIL = [
  '毎週',
  '隔週',
  '第1',
  '第2',
  '第3',
  '第4',
  '第5'
]

/**
 * 賃金区分
 */
export const WAGE_SELECTIONS2 = [
  {
    value: '1',
    text: '時給'
  },
  {
    value: '2',
    text: '日給'
  },
  {
    value: '3',
    text: '月給'
  }
]

/**
 * ドメインリスト
 */
export const DOMAIN_SELECTIONS = [
  { val: '@gmail.com' },
  { val: '@yahoo.co.jp' },
  { val: '@outlook.com' },
  { val: '@icloud.com' },
  { val: '@docomo.ne.jp' },
  { val: '@ezweb.ne.jp' },
  { val: '@softbank.ne.jp' },
  { val: '@rakumail.jp' }
]

/**
 * 親族の関係
 */
export const FAMILIY_RELATIONS = [
  {
    text: '夫'
  },
  {
    text: '妻'
  },
  {
    text: '兄'
  },
  {
    text: '姉'
  },
  {
    text: '弟'
  },
  {
    text: '妹'
  },
  {
    text: '息子'
  },
  {
    text: '娘'
  },
  {
    text: 'いとこ'
  }
]

/**
 * 巡回清掃で過去のフォーマット希望
 */
export const RLS_OLD_FORMAT = {
  // client: ['ジャストアメニティ'],
  site: [
    // ラ・フロレスタ壱番館
    { name: 'フロレスタ壱番館', address: '東京都品川区豊町6' },
    // Terrace世田谷上町
    { name: 'Terrace世田谷上町', address: '東京都世田谷区世田谷2' },
    // ピースフルパレス品川
    { name: 'ピースフルパレス品川', address: '東京都品川区南品川4' },
    // ベイルーム新子安
    { name: 'ベイルーム新子安', address: '神奈川県横浜市神奈川区神之木台29' }
  ]
}

/**
 * 定期清掃にて、野村不動産パートナーズ様の物件の報告書様式が順次変更になる
 * （いつか全て新書式になるので、それまでは特定の物件のみ新書式）
 * バック側も変更！
 */
export const FIXED_NEW_TEMP_NOMURA = [
  { siteCode: '100719106', siteName: 'ブリリアンコート二子玉川' },
  { siteCode: '100719092', siteName: 'プラウド調布柴崎' },
  { siteCode: '100719093', siteName: 'ラコント調布柴崎' },
  { siteCode: '100719091', siteName: 'コンフォラス京王多摩川' },
]

/**
 * RLS の特別仕様（得意先ごとの独自フォーマットの報告書）
 * キーが仕様のコード（mst_rls_special.format）。箇所の数は固定で、items は初期値（'' は物件ごとに決める箇所）
 * 仕様を増やすときはここに足し、報告書の画面と PDF も作る
 */
export const RLS_SPECIAL_FORMATS = {
  before_after: {
    name: '清掃前・清掃後',
    // ダウンロードのファイル名に付ける名前（バックの tblRlsSpecial.FORMAT_NAMES と同じ）
    fileName: '清掃前後',
    note: '1 箇所につき清掃前・清掃後の 2 枚。写真は 12 枚固定',
    itemCount: 6,
    items: ['エントランス', '共用廊下', '共用階段', 'ごみ置場', '', ''],
    // この仕様を設定できる得意先（得意先名に含まれる文字。空なら全部の物件）
    clients: ['シナネンアクシア']
  }
}